"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBusy = exports.checkAndConvertNumber = exports.toFormData = exports.reOrderAttachmentAfterDelete = exports.reOrderImageAfterDelete = exports.uuid = exports.toBoolean = exports.clamp = exports.FormTypes = void 0;
var ApiStore_1 = __importDefault(require("../stores/ApiStore"));
var FormTypes;
(function (FormTypes) {
    FormTypes[FormTypes["CREATE"] = 0] = "CREATE";
    FormTypes[FormTypes["EDIT"] = 1] = "EDIT";
})(FormTypes = exports.FormTypes || (exports.FormTypes = {}));
exports.clamp = function (min, value, max) {
    if (value < min)
        return min;
    if (value > max)
        return max;
    return value;
};
exports.toBoolean = function (string) { return string === 'true'; };
exports.uuid = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};
exports.reOrderImageAfterDelete = function (deletedImage, images) {
    return images.slice()
        .filter(function (image) { return image.id !== deletedImage.id; })
        .map(function (image) {
        if (image.displayOrder > deletedImage.displayOrder) {
            return __assign(__assign({}, image), { displayOrder: image.displayOrder - 1 });
        }
        return image;
    });
};
exports.reOrderAttachmentAfterDelete = function (deletedAttachment, attachments) {
    return attachments.slice()
        .filter(function (attachment) { return attachment.id !== deletedAttachment.id; })
        .map(function (attachment) {
        if (attachment.displayOrder > deletedAttachment.displayOrder) {
            return __assign(__assign({}, attachment), { displayOrder: attachment.displayOrder - 1 });
        }
        return attachment;
    });
};
exports.toFormData = function (json) {
    var formData = new FormData();
    for (var k in json) {
        if (json.hasOwnProperty(k)) {
            formData.append(k, json[k]);
        }
    }
    return formData;
};
exports.checkAndConvertNumber = function (string) {
    var regEx = /^\d+$/;
    if (regEx.test(string)) {
        return parseFloat(string);
    }
    return string;
};
exports.isBusy = function (route) {
    return ApiStore_1.default.data.busyRoutes.includes(route);
};
